import { Dashboard, User } from '@apis/index'
import GridCard, { IGridItem } from '@components/gridCard'
import { StyleColumn } from '@components/styles'
import Tab from '@components/tab'
import { Actions, store } from '@store/index'
import { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import UserInfo from '../components/userInfo'
import BookBorrowed from './tabs/bookBorrowed'
import BookLent from './tabs/bookLent'
import BookListed from './tabs/bookListed'
import CustomerDetail from './tabs/customerDetails'
import { differenceInDays } from 'date-fns'

const AdminUserView = () => {
  const { id: userId } = useParams()
  const { data: user } = useSelector((state: any) => state.singleUser)
  const { data: dashboard } = useSelector(
    (state: any) => state.singleUserDashboard,
  )
  const fetchDashboard = async () => {
    const params = {
      type: 'singleUser',
      userId: userId,
    }
    await Dashboard.getAllDashboardCount('singleUserDashboard', params)
  }
  const items: IGridItem[] = [
    {
      title: user?.status,
      value:
        user?.status == 'Subscribed' && user?.transactionData?.expiresIn
          ? `Expires in ${differenceInDays(user?.transactionData?.expiresIn, today)} days`
          : '',
      Icon: 'mailIcon',
      tc: 'greyText',
      IconBg:
        user?.status == 'Subscribed' && user?.transactionData?.expiresIn
          ? 'greenLight'
          : 'redLight',
      font: 14,
    },
    {
      title: 'Total Books',
      value: dashboard?.totalBook || '0',
      Icon: 'finger',
    },
    {
      title: 'Book Lend',
      value: dashboard?.totalLendBook || '0',
      Icon: 'handSave',
      IconBg: 'redLight',
    },
    {
      title: 'Book Borrowed',
      value: dashboard?.totalBorrowedBook || '0',
      Icon: 'handSave',
      IconBg: 'yellowLight',
    },
  ]
  const tabItems = [
    { key: 'detail', label: 'Customer Details', render: <CustomerDetail /> },
    { key: 'bookListed', label: 'Book listed', render: <BookListed /> },
    { key: 'bookLent', label: 'Book Lent', render: <BookLent /> },
    { key: 'bookBorrowed', label: 'Book Borrowed', render: <BookBorrowed /> },
  ]

  const findUser = async () => {
    await User.find('set', 'singleUser', userId).catch(() => {})
  }
  useEffect(() => {
    fetchDashboard()
    if (!user?.id && !!userId) {
      findUser()
    }
    return () => {
      store?.dispatch(Actions.reset('userBookLent'))
      store?.dispatch(Actions.reset('singleUser'))
      store?.dispatch(Actions.reset('userBooks'))
      store?.dispatch(Actions.reset('userBookBorrow'))
    }
  }, [])
  return (
    <Fragment>
      <StyleColumn>
        <GridCard items={items} leftComponent={<UserInfo user={user} />} />

        <Tab items={tabItems} activeTab="detail" />
      </StyleColumn>
    </Fragment>
  )
}

export default AdminUserView

const today = new Date()
